import React from "react";

function Rounded({text}) {
  return <button className="btn btn-outline rounded-full px-5">{text}</button>;
}

export default Rounded;
